import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {StudentService} from '../../../shared/services/student.service';
import {AdminService} from '../../../shared/services/admin.service';
import {LocaleService} from '../../../shared/services/locale.service';
import {ModelTeacherprofile} from '../../../model/model.teacherprofile';
import {TeacherService} from '../../../shared/services/teacher.service';

@Component({
    selector: 'app-modal-admin-teacherprofile',
    templateUrl: './modal-admin-teacherprofile.component.html',
    styleUrls: ['./modal-admin-teacherprofile.component.scss'],
    standalone: false
})
export class ModalAdminTeacherprofileComponent implements OnInit {

  public data:any;

  public entity: ModelTeacherprofile = {
    id: '',
    firstName: '',
    infix:'',
    lastName: '',
    phoneNumber: '',
    address: {
      street: '',
      number: '',
      numberSuffix: '',
      city: '',
      postalCode: '',
      country: '',
    },
    allowEmailNotifications: false,
    isSubscribedToNewsletter: false
  };

  /**
   * Constructor
   *
   * @param activeModal
   * @param adminService
   * @param locale
   */
  constructor(public activeModal: NgbActiveModal,
              public teacherService: TeacherService,
              public adminService: AdminService,
              public locale: LocaleService) {


  }

  ngOnInit(): void {

    this.entity = Object.assign({}, this.data.entity);

  }

}
